export const SETTING_MESSAGE="Application Settings page will be available soon."